import { Box, IBoxProps } from '~/commonComponents/Box';
import { Colors } from '~/themes/colors';

export const Card = ({ children, ...rest }: IBoxProps) => {
  return (
    <Box
      borderRadius={8}
      backgroundColor={Colors.white}
      boxShadow="0px 1px 2px 1px rgba(0, 0, 0, 0.15)"
      {...rest}
    >
      {children}
    </Box>
  );
};
